import { useNavigate, useLocation } from 'react-router-dom'
import { Home, ArrowLeft, MapPinOff } from 'lucide-react'

export default function NotFoundPage() {
  const navigate = useNavigate()
  const location = useLocation()

  return (
    <div className="min-h-screen flex items-center justify-center bg-cream-50 px-4">
      <div className="text-center max-w-md">
        <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-beige-100 flex items-center justify-center">
          <MapPinOff className="w-10 h-10 text-beige-400" />
        </div>

        <h1 className="text-6xl font-bold text-brown-900 mb-2">404</h1>
        <h2 className="text-xl font-semibold text-brown-700 mb-3">Page introuvable</h2>
        <p className="text-brown-500 mb-2">
          La page <code className="px-1.5 py-0.5 bg-beige-100 rounded text-sm text-brown-700">{location.pathname}</code> n'existe pas.
        </p>
        <p className="text-sm text-brown-400 mb-8">
          Elle a peut-etre ete deplacee ou supprimee.
        </p>

        <div className="flex items-center justify-center gap-3">
          <button
            onClick={() => navigate(-1)}
            className="inline-flex items-center gap-2 px-4 py-2.5 text-sm font-medium text-brown-700 bg-white border border-beige-200 rounded-lg hover:bg-beige-50 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Retour
          </button>
          <button
            onClick={() => navigate('/dashboard')}
            className="inline-flex items-center gap-2 px-4 py-2.5 text-sm font-medium text-white bg-mint-600 rounded-lg hover:bg-mint-700 transition-colors"
          >
            <Home className="w-4 h-4" />
            Tableau de bord
          </button>
        </div>
      </div>
    </div>
  )
}
